import { css } from "@emotion/react";
import Mixin from "../../../util/mixin";


export class CaretDown extends Mixin {
  style({$}) {
    const { caretWidth } = $;
    return css`
      border-top: ${caretWidth} solid;
      border-right: ${caretWidth} solid transparent;
      border-bottom: 0;
      border-left: ${caretWidth} solid transparent;
    `;
  }
}


export class CaretUp extends Mixin {
  style({$}) {
    const { caretWidth } = $;
    return css`
      border-top: 0;
      border-right: ${caretWidth} solid transparent;
      border-bottom: ${caretWidth} solid;
      border-left: ${caretWidth} solid transparent;
    `;
  }
}


export class CaretRight extends Mixin {
  style({$}) {
    const { caretWidth } = $;
    return css`
      border-top: ${caretWidth} solid transparent;
      border-right: 0;
      border-bottom: ${caretWidth} solid transparent;
      border-left: ${caretWidth} solid;
    `;
  }
}


export class CaretLeft extends Mixin {
  style({$}) {
    const { caretWidth } = $;
    return css`
      border-top: ${caretWidth} solid transparent;
      border-right: ${caretWidth} solid;
      border-bottom: ${caretWidth} solid transparent;
    `;
  }
}


export class Caret extends Mixin {
  style({$}, [direction = "down"]) {
    return $.enableCaret ? css`
      &::after {
        display: inline-block;
        margin-left: ${$.caretSpacing};
        vertical-align: ${$.caretVerticalAlign};
        content: "";
        ${direction === "down" ? (
          new CaretDown().include($)
        ) : direction === "up" ? (
          new CaretUp().include($)
        ) : direction === "right" ? (
          new CaretRight().include($)
        ) : (
          css``
        )}
      }

      ${direction === "left" ? css`
        &::after {
          display: none;
        }

        &::before {
          display: inline-block;
          margin-right: ${$.caretSpacing};
          vertical-align: ${$.caretVerticalAlign};
          content: "";
          ${new CaretLeft().include($)};
        }
      `: css``}

      &:empty::after {
        margin-left: 0;
      }
    `: css``;
  }
};
